<parkour-action [link]="['uitnodiging', uitnodiging.id]">
  @if (aanvaardeUitnodiging$ | async; as aanvaardeUitnodiging) {
    @if (
      aanvaardeUitnodiging !== 'NOT_AANVAARD' &&
      aanvaardeUitnodiging.profiel.status === 'UITGENODIGD'
    ) {
      <parkour-teammember-uitnodiging-item
        [image]="{
          type: 'image',
          src: aanvaardeUitnodiging.profiel | profielFoto | async,
          alt: 'Profielfoto van ' + (aanvaardeUitnodiging.profiel | profielnaam),
        }"
        [naam]="aanvaardeUitnodiging.profiel | profielnaam"
        [professioneel]="aanvaardeUitnodiging.profiel.verificatieStatus === 'GEVERIFIEERD'"
        [rol]="uitnodiging.rol"
        [status]="uitnodiging.status"
      >
        @if (uitnodiging.status) {
          <parkour-tag [variant]="'cyan'">{{ getStatusLabel(uitnodiging.status) }} </parkour-tag>
        }
      </parkour-teammember-uitnodiging-item>
    }
    @if (aanvaardeUitnodiging === 'NOT_AANVAARD') {
      <parkour-teammember-uitnodiging-item
        [image]="{ type: 'icon', name: 'people-3' }"
        [naam]="uitnodiging.naam"
        [rol]="uitnodiging.rol"
        [status]="uitnodiging.status"
      >
        @if (uitnodiging.status) {
          <parkour-tag [variant]="'light-blue'"
            >{{ getStatusLabel(uitnodiging.status) }}
          </parkour-tag>
        }
      </parkour-teammember-uitnodiging-item>
    }
  }
</parkour-action>
